import { call, put } from 'redux-saga/effects';

import { IGetAuthTokenResponse } from 'api/components/Auth/types';
import api from 'api';

import { getAuthTokenError, getAuthTokenSuccess } from '../actions';

import sentry from 'services/Sentry/SentryInstance';

export function* getAuthTokenSaga() {
    try {
        const { auth_token }: IGetAuthTokenResponse = yield call(api.auth.getAuthToken);

        yield put(getAuthTokenSuccess(auth_token));
    } catch (error: any) {
        yield put(getAuthTokenError());

        sentry.sentrySagaLog(error, 'getAuthTokenSaga');
    }
}
